import { Box, Paper } from "@mui/material";
import { showErrorToast, showSuccessToast } from "@/utils/toast-utils";
import FeedbackPanel, {
  FeedbackContext,
  FeedbackPayload,
} from "@/components/feedback/FeedbackPanel";
import { submitFeedback } from "@/lib/apiService";

const FeedbackPage = () => {
  const handleSubmit = async (payload: FeedbackPayload) => {
    const numericRating = payload.rating ? Number(payload.rating) : undefined;

    try {
      await submitFeedback({
        feedbackType: payload.context,
        title: payload.title,
        feedbackText: payload.details,
        rating: Number.isFinite(numericRating || NaN) ? numericRating : undefined,
        passFail: payload.result || undefined,
        feedbackDate: new Date().toISOString().split("T")[0],
      });

      showSuccessToast("Feedback submitted", "Thanks for sharing your feedback with the Nourish team.");
    } catch (error) {
      console.error("Failed to submit feedback", error);
      showErrorToast(error, "Feedback submission failed");
      throw error;
    }
  };

  return (
    <Box sx={{ position: 'relative', py: 1, mt: { lg: 1.5 }, ml: { lg: 0.5 } }}>
      <Paper
        elevation={0}
        sx={{
          minHeight: 'calc(100vh - 7.5rem)',
          overflow: 'hidden',
          borderRadius: '28px',
          border: '1px solid rgba(15, 23, 42, 0.08)',
          bgcolor: '#fff',
        }}
      >
        <div className="max-w-4xl space-y-6 p-4 sm:p-5 lg:px-7 lg:pt-6 lg:pb-7">
      <div className="space-y-1">
        <h1 className="text-3xl font-semibold tracking-tight">
          Submit product feedback
        </h1>
        <p className="text-muted-foreground">
          Let us know what’s working, what’s broken, and what you’d like us to
          build next. Your notes go straight to the product team.
        </p>
      </div>
      <FeedbackPanel
        title="Share feedback"
        description="Please provide feedback on the overall usability of the application"
        titlePlaceholder="Short summary (e.g., Draft meal plan issues)"
        detailsPlaceholder="Please provide feedback on the overall usability of the application"
        submitLabel="Send Feedback"
        defaultContext={FeedbackContext.OVERALL_APPLICATION}
        variant="inline"
        onSubmit={handleSubmit}
      />
    </div>
      </Paper>
    </Box>
  );
};

export default FeedbackPage;
